import type {
  AiAgentSection,
  WidgetRelatedApp
} from '@inno-tools/container-bridge'
import { create } from 'zustand'

type WidgetMarketplaceFilterStore = {
  pendingRelatedApp: WidgetRelatedApp | null
  pendingSection: AiAgentSection | null
  setPendingRelatedApp: (value: WidgetRelatedApp | null) => void
  setPendingSection: (value: AiAgentSection | null) => void
}

export const useWidgetMarketplaceFilterStore =
  create<WidgetMarketplaceFilterStore>(set => ({
    pendingRelatedApp: null,
    pendingSection: null,
    setPendingRelatedApp: value => set({ pendingRelatedApp: value }),
    setPendingSection: value => set({ pendingSection: value })
  }))
